import {  SITE_URL, API_GATEWAY } from "/constants/API_constants.js";

export async function getCommentariesForNode(branchId, page) {
    const url = new URL(API_GATEWAY+"commentaries/get/list/for-branch");
    url.searchParams.append("branchId", branchId);
    url.searchParams.append("page", page);

    const response = await fetch(url, {
        method : 'GET'
    });

    if(!response.ok)
        return null;

    const data = await response.json();

    return data;
}

export async function getCommentariesByIdList(ids) {
    const url = new URL(API_GATEWAY+"commentaries/get/list/by-ids");
    url.searchParams.append("ids", ids);

    const response = await fetch(url, {
        method : 'GET'
    });

    if(!response.ok)
        return null;

    const data = await response.json();

    return data;
}